// src/portal/components/PortalProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const PortalProtectedRoute = ({ children, requiredRole = null }) => {
    const { isAuthenticated, loading, user } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
            </div>
        );
    }

    if (!isAuthenticated) {
        const isOwnerRoute = location.pathname.startsWith('/portal/owner');
        const isVendorRoute = location.pathname.startsWith('/portal/vendor');
        let loginPath = '/portal/tenant/login';
        if (isOwnerRoute) loginPath = '/portal/owner/login';
        if (isVendorRoute) loginPath = '/login';
        
        return <Navigate to={loginPath} state={{ from: location }} replace />;
    }

    if (requiredRole && user?.role !== requiredRole) {
        if (user?.role === 'tenant') return <Navigate to="/portal/tenant/dashboard" replace />;
        if (user?.role === 'owner') return <Navigate to="/portal/owner/dashboard" replace />;
        if (user?.role === 'vendor') return <Navigate to="/portal/vendor/dashboard" replace />;
        return <Navigate to="/admin/dashboard" replace />;
    }

    return children;
};

export default PortalProtectedRoute;
